import { StartupScreen } from "@cliqsuite/ui";
import { useState } from "react";
import { Outlet, useRouterState } from "@tanstack/react-router";
import { AdminAuthProvider, useAdminAuth } from "../state/AdminAuthContext";
import { AdminDataProvider, useAdminData } from "../state/AdminDataContext";
import { useIsDesktop } from "../hooks/useIsDesktop";
import { LoginScreen } from "../components/LoginScreen";
import { Sidebar, PAGE_TITLES } from "../components/Sidebar";
import { HEADER_ACTIONS_ID } from "../components/PageHeaderActions";
import { ToastHost } from "../components/ToastHost";
import { UpdateBanner } from "../components/UpdateBanner";

function AuthedShell() {
  const { user, logout } = useAdminAuth();
  const { payments } = useAdminData();
  const isDesktop = useIsDesktop();
  const [navOpen, setNavOpen] = useState(false);
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const pendingCount = payments.filter((p) => p.status === "pending").length;
  const meta = PAGE_TITLES[pathname] ?? PAGE_TITLES["/"]!;

  return (
    <div className="o-shell o-shell--ink">
      {isDesktop && <Sidebar pendingCount={pendingCount} adminName={user?.name ?? "Admin"} onLogout={logout} />}
      {!isDesktop && navOpen && (
        <>
          <div className="o-side-backdrop" onClick={() => setNavOpen(false)} />
          <Sidebar drawer pendingCount={pendingCount} adminName={user?.name ?? "Admin"} onLogout={logout} onNavigate={() => setNavOpen(false)} />
        </>
      )}
      <main className="o-sheet">
        <div className="o-page">
          <header className="o-head">
            {!isDesktop && (
              <button type="button" aria-label="Open navigation" className="o-head__btn" onClick={() => setNavOpen(true)}>
                <span className="ms" aria-hidden="true">menu</span>
              </button>
            )}
            <div className="o-head__text">
              <h1>{meta.title}</h1>
              <div>{meta.sub}</div>
            </div>
            <div id={HEADER_ACTIONS_ID} className="o-head__actions" />
          </header>
          <Outlet />
        </div>
      </main>
      <ToastHost />
    </div>
  );
}

function RootLayoutInner() {
  const { authed, loading } = useAdminAuth();
  if (loading && authed) {
    return <StartupScreen app="ADMIN" dark label="Checking your session" />;
  }
  if (!authed) return <LoginScreen />;
  return (
    <AdminDataProvider>
      <AuthedShell />
    </AdminDataProvider>
  );
}

export function RootLayout() {
  return (
    <AdminAuthProvider>
      <UpdateBanner />
      <RootLayoutInner />
    </AdminAuthProvider>
  );
}
